import { ChangeEvent, FunctionComponent, useEffect, useRef, useState } from "react";
import deletemodelpopup from "../../assets/popup/deletemodelpopup.svg";
import cdDsahboradTime from "../../assets/cdDsahborad--time.png";
import cdDsahboradPrfile from "../../assets/cdDsahborad-profile.png";
import { useForm } from "react-hook-form";
import InputsNew from "../common/InputsNew";
import { uploadFileDirectly } from "../../pages/projects/AddProject";
import plusIconuplad from "../../assets/task/plus_icon_uload.svg";
import imageDocumenticon from "../../assets/task/Image-document.svg";
import documentBusinessdocu from "../../assets/task/document_business_docu.svg";
import downloaDoutlineicon from "../../assets/task/Download outline.svg";
import viewMeeting from "../../assets/task/eye-show-svgrepo-com.svg";
import { LinkItem, LinkManager } from "./LinkManager";

interface NotifyProps {
    email?: any
    onsubmit?: any;
    back?: any;
    removeExtraCSS?: boolean;
    isDelete?: any;
    filter?: string
}

const ReplyPopup: FunctionComponent<NotifyProps> = ({
    email,
    onsubmit,
    back,
    removeExtraCSS,
    isDelete,
    filter
}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [imgUrls, setImgUrls] = useState<string[]>([]);
    const [fileNames, setFileNames] = useState<string[]>([]);
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [validationMessage, setValidationMessage] = useState<string | null>(null);
    const [links, setLinks] = useState<LinkItem[]>([]);
    const [showPreviousReply, setShowPreviousReply] = useState(false)
    // const [loading, setLoading] = useState(false)

    const {
        handleSubmit,
        register,
    } = useForm<any>({
        defaultValues: {
            // followUpNeeded: filter === "Home" ? false : true
            followUpNeeded: true
        }
    });

    useEffect(() => {
        document.body.classList.add("coverflow_hidden_scoll_bdy");

        return () => {
            document.body.classList.remove("coverflow_hidden_scoll_bdy");
        };
    }, []);

    function handleIconClick() {
        fileInputRef.current?.click();
    }

    async function handleFileUpload(event: ChangeEvent<HTMLInputElement>) {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        const token = localStorage.getItem("authToken")!;
        const validTypes = ["image/jpeg", "image/png"];
        // const newImageUrls: string[] = [];
        const newUrls: string[] = [];
        const newNames: string[] = [];

        setIsUploading(true);
        setValidationMessage(null);

        for (const file of Array.from(files)) {
            if (!validTypes.includes(file.type)) {
                setValidationMessage("Only JPG and PNG files are allowed.");
                setIsUploading(false);
                return;
            }

            try {
                const url = await uploadFileDirectly(file, file.name, token);
                newUrls.push(url);
                newNames.push(file.name);
            } catch (err) {
                console.error("Upload failed", err);
            }
        }

        // setImgUrls((prev) => [...prev, ...newImageUrls]);
        setImgUrls((prev) => [...prev, ...newUrls]);
        setFileNames((prev) => [...prev, ...newNames]);
        setIsUploading(false);

        // If needed, set values in your form for each image (optional)
        // e.g., setValue("imageUrls", [...imgUrls, ...newImageUrls])
    }

    const handleRemoveImage = (index: number) => {
        setImgUrls((prev) => prev.filter((_, i) => i !== index));
        setFileNames((prev) => prev.filter((_, i) => i !== index));
    };

    function onSubmit(data: any) {
        onsubmit(data, email, imgUrls, links)
    }

    return (
        <section id="model-main-blg" className="cdDsahborad_blg_main">
            <div id="inner_loader_dv">
                <div className=" w-[750px] flex flex-row items-start justify-start max-w-[750px] mq575:w-full z-[1] mq825:max-w-full m-4 viewinterction_cts-width relative">
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                        className={`w-full right-0 absulate  mq575:max-h-[600px] mq575:overflow-hidden top-0  m-0 flex-1 rounded-radius-radius-lg bg-white border-[1px] border-solid border-surface-border  h-[100vh]  flex flex-col items-center justify-start ${removeExtraCSS === true ? "" : "p-4"} mq575:p-3 box-border gap-[23.8px] max-w-full mq825:pt-[21px] mq825:pb-[21px] mq825:box-border`}
                    >
                        <div className="p-0 mq575:p-0 min-w-full relative grid gap-[16px]">
                            {/* <b>{msgHeading}</b> */}

                            <b className="flex-1 text-xl-dv relative text-black inline-block max-w-[calc(100%_-_34px)] dark:text-white">Email Details</b>
                            <img
                                src={deletemodelpopup}
                                alt=""
                                className="cursor-pointer pr-0  mq575:pr-0 mq575:pt-0 w-5 h-5 absolute right-0 top-[-5px]  mq575:top-0 mq575:w-3 mq575:h-3 dark-white-img "
                                style={{}}
                                onClick={() => back(false)}
                            />
                            <div className="cdDsahborad_main overflow-y-auto  max-h-[960px]  mq575:max-h-[600px]">
                                <div className="w-full grid mq575:inline-block gap-[24px] mb-[100px]">
                                    <div className="cdDsahborad_content ">
                                        <div className="cdDsahborad_emaildetail">
                                            <div className="inner_emaildetail_profile mb-2">
                                                <div className="emaildetail_profile">
                                                    <img src={cdDsahboradPrfile} className="w-6 h-6 relative top-[4px]" alt="" />
                                                </div>
                                                <div className="emaildetail_profile_cont items-center">
                                                    <p className="text-sm dark:text-white my-0 email-label-dv"><b>From</b></p>
                                                    <p className="text-sm dark:text-white my-0">{email?.from}</p>
                                                </div>
                                            </div>
                                            <div className="inner_emaildetail_profile mb-2">
                                                <div className="emaildetail_profile">
                                                    <img src={cdDsahboradTime} className="w-6 h-6 relative top-[4px]" alt="" />
                                                </div>
                                                <div className="emaildetail_profile_cont items-center">
                                                    <p className="text-sm dark:text-white my-0 email-label-dv"><b>Received</b></p>
                                                    <p className="text-sm dark:text-white my-0">{email?.received_date}</p>
                                                </div>
                                            </div>
                                            <div className="subjectline-dv w-full mb-2 mt-6">
                                                <p className="text-sm dark:text-white my-0 email-label-dv"><b>Subject</b></p>
                                                <p className="text-sm dark:text-white my-0">{email?.subject}</p>
                                            </div>
                                        </div>
                                        <div className="cdDsahborad_status mb-4">
                                            <div className="inner_cdDsahborad_status grid gap-[8px]">
                                                <label className="flex items-center gap-2 cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        {...register("followUpNeeded")}
                                                        className="hidden peer"
                                                    />
                                                    <div className="w-10 h-5 bg-gray-300 rounded-full peer-checked:bg-green-500 relative transition-all toggle-input-blg">
                                                        <div className="absolute left-0 top-0 w-5 h-5 bg-white rounded-full shadow transition-all peer-checked:left-5"></div>
                                                    </div>
                                                    <span className="text-sm dark:text-white">
                                                        Follow-up Needed
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    {email?.attachments_urls?.length > 0 && (
                                        <div className="customerattachment_list-items">
                                            <p className="text-sm dark:text-white my-0 email-label-dv mb-2"><b>Customer Attachments</b></p>
                                            <div className="customerattachment_list py-1 pr-4 grid gap-[8px] max-h-[130px] overflow-y-auto">
                                                {email?.attachments_urls?.map((a: any) => {
                                                    return (
                                                        <a
                                                            key={a}
                                                            href={a}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="cursor-pointer items_customerattachment_list flex justify-between border-[1px] border-solid border-surface-border py-2.5 px-[15px] dark:bg-slate-700"
                                                        >
                                                            {/* <div className="cursor-pointer items_customerattachment_list flex justify-between border-[1px] border-solid  border-surface-border  py-2.5 px-[15px] dark:bg-slate-700 "> */}
                                                            <div className="flex gap-[8px] items-center mq575:grid">
                                                                <img src={documentBusinessdocu} className="w-5 h-5" alt="" />
                                                                <p className="my-0 dark:text-white text-black text-sm">{a}</p>
                                                            </div>
                                                            {/* <div className="flex gap-[8px] items-center">
                                                                <p className="my-0 dark:text-white text-black text-sm">240 KB</p>
                                                                <img src={downloaDoutlineicon} className="w-3 h-3" alt="" />
                                                            </div> */}
                                                            {/* </div> */}
                                                        </a>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )}

                                    <div className="grid gap-[8px] custom-mr-dv">
                                        <p className="text-sm dark:text-white my-0 email-label-dv"><b>Message</b></p>
                                       <div  className="cdDsahborad_chatmessage bg-white p-2 my-0 break-words">
                                         <p className=" my-0 break-words">
                                            {email?.email_body}
                                        </p>
                                       </div>
                                    </div>

                                    {email?.replies?.length > 0 && (
                                        <div className="grid gap-[8px] ">
                                            <button className="max-w-[300px] mq575:max-w-[100px] viewreply-btn-dv cursor-pointer bg-white py-2.5 h-[44px] mq575:h-[35px] px-[42px] text-black mq575:py-[12.5px] mq575:px-[25px] rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100 hover:box-border hover:border-[2px] hover:border-solid hover:border-dodgerblue"
                                                onClick={() => setShowPreviousReply(!showPreviousReply)}
                                                type="button"
                                            >
                                                <div className="relative text-sm font-body-xs-semi-bold text-black dark:text-white text-center flex gap-[4px] items-center">
                                                    <img
                                                        className="h-5 w-5 relative overflow-hidden shrink-0 cursor-pointer"
                                                        alt=""
                                                        src={viewMeeting}

                                                    />
                                                    <span>View Reply</span>
                                                </div>
                                            </button>

                                            {showPreviousReply && (
                                                <div className="grid gap-[8px] reply_main_section">
                                                    <p className="text-sm dark:text-white my-0 email-label-dv"><b>Previous Reply</b></p>
                                                    {email?.replies?.map((r: any, index: number) => {
                                                        return (
                                                            <>
                                                                Reply #{index}

                                                                <div className="cdDsahborad_chatmessage bg-white">

                                                                    {r?.body}
                                                                    {r?.attachments_urls?.length > 0 && (
                                                                        <div className="customerattachment_list-items">
                                                                            <p className="text-sm dark:text-white my-0 email-label-dv mb-2"><b>Attachments</b></p>
                                                                            <div className="customerattachment_list py-2 pr-4 grid gap-[8px] max-h-[130px] overflow-y-auto">
                                                                                {r?.attachments_urls?.map((a: any) => {
                                                                                    return (
                                                                                        <a
                                                                                            key={a}
                                                                                            href={a}
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                            className="cursor-pointer items_customerattachment_list flex justify-between border-[1px] border-solid border-surface-border py-2.5 px-[15px] dark:bg-slate-700"
                                                                                        >
                                                                                            <div className="flex gap-[8px] items-center">
                                                                                                <img src={documentBusinessdocu} className="w-5 h-5" alt="" />
                                                                                                <p className="my-0 dark:text-white text-black text-sm">{a}</p>
                                                                                            </div>
                                                                                        </a>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div className="grid gap-[8px] custom-mr-dv">
                                        <p className="text-sm dark:text-white my-0 email-label-dv"><b>Reply</b></p>
                                        <div className="cdDsahborad_reply bg-white">
                                            <InputsNew
                                                contentPlaceholder="reply"
                                                // label="Goal Description"
                                                type="textarea"
                                                register={register('reply')}
                                            // errorMessage={errors.reply}
                                            />
                                        </div>
                                    </div>

                                    <div className="custom-mr-dv grid grid-cols-1 mq1400:grid-1 mq1275:grid-cols-1 mq950:mq1275:grid-cols-1 mq575:mq1275:grid-cols-1 gap-[16px]">
                                        <div className="rounded flex flex-col items-start justify-start text-left min-w-[22%]">
                                            <p className="text-sm dark:text-white my-0 email-label-dv mb-4"><b>Add Attachments</b></p>
                                            <div className="grid flex-wrap gap-4 items-center add_attachments_blg">
                                                {/* Upload box or uploading state */}
                                                <div className="max-w-[100%] ">
                                                    <div className="document-uploded-list">
                                                        {isUploading ? (
                                                            <div className="w-full h-28 flex items-center justify-center border border-dashed border-neutral-300">
                                                                <span className="text-blue-500">Uploading...</span>
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="w-full h-24 flex flex-col items-center justify-center border border-dashed border-neutral-300 cursor-pointer gap-[8px] "
                                                                onClick={handleIconClick}
                                                            >
                                                                <div className="cursor-pointer flex flex-col items-start justify-start p-[5px] plus-task-btn taskdash-plush-img rounded">
                                                                    <img src={plusIconuplad} alt="Upload" className="w-5 h-5" />
                                                                </div>

                                                                <p className="text-sm dark:text-white my-0">Add more</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                {/* Uploaded images */}
                                                <div className="flex gap-[8px] max-h-[280px] overflow-y-auto flex-wrap upliedlist-items-dv">
                                                    {imgUrls.map((url, index) => (
                                                        <div key={index} className="bg-white p-2 w-[160px] shadow border rounded relative customerattachment_list py-2 pr-4 grid gap-[8px] max-h-[230px] overflow-y-auto">
                                                            {/* ❌ Delete icon */}
                                                            <button
                                                                type="button"
                                                                onClick={() => handleRemoveImage(index)}
                                                                className="absolute top-1 right-1 red-clockout-btn-dv cursor-pointer rounded-full py-[2px] px-[2px] shadow hover:bg-red-100 z-10"
                                                                title="Remove image"
                                                            >
                                                                <span className="text-red-500 font-bold text-lg text-white">×</span>
                                                            </button>

                                                            <img
                                                                className="w-36 h-24 object-cover cursor-pointer"
                                                                src={url}
                                                                alt={`Uploaded ${index}`}
                                                                onClick={() => handleRemoveImage(index)}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>

                                            </div>

                                            {/* Hidden file input */}
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                style={{ display: "none" }}
                                                onChange={handleFileUpload}
                                                accept=".jpg,.jpeg,.png"
                                                multiple
                                            />

                                            {/* Error Message */}
                                            {validationMessage && (
                                                <p className="text-red-500 text-sm mt-2 flex items-center gap-2">
                                                    <span>⚠️</span> {validationMessage}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <LinkManager links={links} onLinksChange={setLinks} />

                                    {/* button */}
                                    {/* {isUploading == false && (
                                        <div
                                            className={`custom-mr-dv grid gap-[16px] mq575:gap-[16px] ${removeExtraCSS === true ? "pl-5 pb-5 pr-5" : ""
                                                } `}
                                        >
                                            <div
                                                className={`self-stretch mt-[24px] flex flex-row items-center justify-end py-0 pr-0 gap-[8px] mq450:box-border mq950:box-border mq1425:flex-wrap mq1425:box-border min-w-full ${removeExtraCSS === true ? "flex justify-end" : ""
                                                    } `}
                                            >
                                                <button
                                                    disabled={true}
                                                    type="submit"
                                                    className={`cursor-pointer [border:none]  py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue ${isDelete == true ? "modeldelete_btn_dv" : ""
                                                        } `}
                                                >
                                                    <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block min-w-[32px]">
                                                        Send
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    )} */}
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};
export default ReplyPopup;
